import { CONTRACT_VERSION } from './contract-version'

/**
 * Configurazione da variabili d'ambiente Vite. Vedi `.env.example`.
 *
 * Tutto ciò che è ambiente passa da qui: nessun `import.meta.env` sparso nel codice,
 * così il perimetro configurabile è leggibile in un colpo d'occhio.
 */

function flag(value: string | undefined, fallback = false): boolean {
  if (value === undefined) return fallback
  return value === 'true' || value === '1'
}

/** Come viaggia il refresh token. Vedi la nota in README sulla scelta. */
export type RefreshTransport = 'body' | 'cookie'

export const config = {
  /** Base URL dell'API, prefisso `/v1` incluso. */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? '/v1').replace(/\/+$/, ''),

  /**
   * MSW intercetta le chiamate e serve dati conformi al contract. Serve finché
   * `gymmi-be` non implementa le rotte `/admin`; mai attivo in produzione.
   */
  enableMocks: import.meta.env.DEV && flag(import.meta.env.VITE_ENABLE_MOCKS, false),

  refreshTransport: (import.meta.env.VITE_AUTH_REFRESH_TRANSPORT ?? 'body') as RefreshTransport,

  isDev: import.meta.env.DEV,

  /** Versione del contract implementata da questa build. */
  contractVersion: CONTRACT_VERSION,
} as const

/**
 * Soglia oltre la quale `unmatchedRateLast7Days` va segnalata come da indagare.
 * Non è nel contract: è una scelta di prodotto del pannello, tenuta qui per essere
 * ritarata senza cercarla nel codice della dashboard.
 */
export const COACH_UNMATCHED_WARN_THRESHOLD = 0.1
export const COACH_UNMATCHED_CRITICAL_THRESHOLD = 0.2
